import { render, staticRenderFns } from "./inisStats.vue?vue&type=template&id=3bff04e6&"
import script from "./inisStats.vue?vue&type=script&lang=js&"
export * from "./inisStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports